<template lang="pug">
span#reports
  div.content-box
    md-card
      md-card-header.md-card-header-icon.md-card-header-green
        div.card-icon
          PersonAdd
        h4.title {{ ($t("webChannel.generalSettings.title")) }}
      v-skeleton-loader(
        v-if="loading"
        height="110"
        style='margin: 30px 0;'
        type="card-heading, image"
      )
      md-card-content(v-else)
        div
          label.txtLabel {{ $t('recoveryTeams.emailInput') }}
          v-text-field(
            v-model="userEmail"
            :error-messages="(userEmail.length > 6 && !checkEmail(userEmail)) ? [$t('recoveryTeams.invalidEmail')] : []"
            style='margin-bottom: 15px; height: 50px;'
            :placeholder="$t('recoveryTeams.emailPlaceholder')"
            :value='userEmail'
            @input='updateSearchItem($event)'
          )
        v-card-actions.text-right(v-if="!saved")
          v-btn(@click='handleNewUser' outlined style='color: #FF0000; margin-right: 10px') {{$t('recoveryTeams.reset')}}
          v-btn(@click='handleConfirmEmail' :disabled="!checkEmail(userEmail)" color='#43a047' style='color:white;') {{$t('recoveryTeams.add')}}
        table.tbBox(v-if="saved")
          tr
            th(scope="col").txtTh {{ $t('recoveryTeams.name') }}
            th(scope="col").txtTh {{ $t('recoveryTeams.userSurname') }}
            th(scope="col").txtTh {{ $t('recoveryTeams.userName') }}
            th(scope="col").txtTh {{ $t('recoveryTeams.userEmail') }}
          tr
            td(scope="row").txtContent {{ data.givenName || '' }}
            td(scope="row").txtContent {{ data.surname || '' }}
            td(scope="row").txtContent {{ getUserName(data.email || data.userPrincipalName).userName }}
            td(scope="row").txtContent {{ getUserName(data.email || data.userPrincipalName).email }}
        v-card-actions.text-right(v-if="saved")
          v-btn(@click='handleNewUser' outlined style='color: #FF0000; margin-right: 10px') {{$t('recoveryTeams.reset')}}
          v-btn(@click='handleNewUser' color='#43a047' style='color:white;') {{$t('recoveryTeams.addNewUser')}}
</template>
<script>
import GlobalDialog from '@/components/Reuse/GlobalDialog'
import StatsCard from '@/components/Cards/StatsCard.vue'
import DataProvider from '@/components/DataProvider'
import DataTable from '@/components/DataTable'
import PersonAdd from '@/assets/img/person_add.svg'
import Swal from 'sweetalert2'
export default {
  data () {
    return {
      loading: false,
      data: null,
      activeSend: false,
      userEmail: '',
      errorEmail: false,
      validEmail: false,
      saved: false
    }
  },
  created () {

  },
  watch: { },
  components: {
    GlobalDialog,
    DataProvider,
    DataTable,
    StatsCard,
    PersonAdd
  },
  computed: { },
  methods: {
    handleNewUser () {
      this.userEmail = ''
      this.saved = false
    },
    handleConfirmEmail () {
      this.requestRecoveryTeams()
    },
    getUserName (email) {
      let userName = { userName: '', email: '' }
      if (email) {
        userName = email.split('@')
        return { userName: userName[0], email }
      }
      return userName
    },
    checkEmail (email) {
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return reg.test(email)
    },
    updateSearchItem (value) {
      this.userEmail = value
    },
    mountUrlAndParams (endpoint) {
      return {
        url: `${process.env.VUE_APP_BACKEND_BASE_URL}/${endpoint}`
      }
    },
    async requestRecoveryTeams () {
      const { url } = this.mountUrlAndParams('recovery-teams')
      this.loading = true
      try {
        let body = { principalName: this.userEmail }
        const response = await this.$axios.post(`${url}`, body)
        if (response && response.status === 201) {
          this.data = response.data
          this.saved = true
          Swal.fire({
            title: this.$t(`recoveryTeams.success`),
            icon: 'success',
            showConfirmButton: false,
            timer: 3000
          })
        }
        if (response && response.status === 200) {
          if (response?.data?.message) {
            this.userEmail = ''
            Swal.fire({
              title: this.$t(`recoveryTeams.${response.data.message}`),
              icon: 'error',
              showConfirmButton: false,
              timer: 3000
            })
          }
        }
      } catch (er) {
        const errorData = er?.response?.data
        if (er?.response && errorData?.error) {
          Swal.fire({
            title: this.$t(`recoveryTeams.${errorData.error}`),
            icon: 'error',
            showConfirmButton: false,
            timer: 3000
          })
        } else {
          Swal.fire({
            title: this.$t(`dialog.internalError`),
            icon: 'error',
            showConfirmButton: false,
            timer: 2000
          })
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss">
@media (max-width: 400px) {
  .content-box {
    float: left;
    padding: 0px;
    width: 100%;
  }
}
.content-box {
  float: left;
  padding: 30px;
  width: 60%;
}
.tbBox {
  border-spacing: 0;
  width: 100%;
}
.txtLabel {
  color: #A8A8A8;
  font-size: 12px;
  font-weight: 400;
}
.txtTh {
  text-align: left;
  color: #A8A8A8;
  font-size: 12px;
  font-weight: 400;
}
.txtContent {
  text-align: left;
  color: #434343;
  font-size: 13px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#reports .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line {
  height: 110px !important;
}
#reports .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line .v-skeleton-loader__paragraph {
  padding-left: 4px !important;
}
</style>
